
import SubCategoriesTable from 'components/SubCategories';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';

export const SubCategories = () => {
  const selectedCompanyPermission = useSelector(
    (state: any) => state?.userProfile?.data?.permissions
  );
  const isCategoriesPermission = checkPermission(selectedCompanyPermission, {
    permissionName: 'Categories',
    permission: ['viewAll'],
  });
  const isSubCategoriesPermission = checkPermission(selectedCompanyPermission, {
    permissionName: 'SubCategories',
    permission: ['viewAll'],
  });
  return <div>{isCategoriesPermission && isSubCategoriesPermission && <SubCategoriesTable />}</div>;
};
